module.exports = __webpack_public_path__ + "static/img/title.9b41caf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/mz_brunegg/title.jpg
// module id = 429
// module chunks = 1